<template>
    <div>
        <div class="successful-flow-modal modal fade" tabindex="-1" role="dialog" aria-labelledby="cancelPayModal" aria-hidden="true">
            <div class="modal-dialog modal-pdv">
                <div class="modal-content">
                    <div class="modal-title">
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Cerrar"
                            @click="onClose"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="main-content">
                        <div class="row justify-content-center">
                            <div class="col-12 col-md-8 col-xl-9 text-content">
                                <div class="content-inner">
                                    <h5 class="mb-4">¡Ya casi terminamos!</h5>
                                    <h6 class="mb-4">Tu reserva de cupos se ha realizado correctamente. <br/>
                                        Por favor, completa el siguiente paso para finalizar.
                                    </h6>
                                    <div class="d-flex align-items-center justify-content-center message">
                                        <span>
                                            RECUERDA QUE LOS CUPOS SE MANTENDRÁN APARTADOS PARA TÍ SOLO DURANTE <b>5 MINUTOS</b> HASTA REALIZAR EL PAGO
                                        </span>
                                    </div>
                                    <br/>
                                    <div class="d-flex justify-content-center">
                                        <button
                                            type="button"
                                            class="btn-outlet-continuar"
                                            @click="onContinue"
                                            data-dismiss="modal"
                                            aria-label="Realizar pago"
                                        >
                                            Realizar Pago
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        data(){
          return {}
        },
        methods: {
            onContinue() {
                this.$emit('onContinue');
            },
            onClose() {
                this.$emit('close');
            }
        }
    }
</script>

<style scoped lang="scss">
    .successful-flow-modal{
        @include media-breakpoint-down(sm){
            padding-right: 0 !important;
        }
        .modal-pdv{
            
            max-width: 951px;
            @include media-breakpoint-down(sm){
                margin: 65px 20px 0px 20px;
            }
            .modal-content {
              position: relative;
              margin-top: 100px;
              border-radius: 24px;
              border: 2px solid $neutralBlack;
              background: $neutralwhite;
              padding: 24px;
              box-shadow: 0 0 12px 3px #00000038;
              @include media-breakpoint-down(sm) {
                padding: 28px 25px;
              }
              h5 {
                  color: $neutralBlack;
                  text-align: center;
                  font-family: 'Poppins-Bold', sans-serif;
                  font-size: 32px;
                  font-style: normal;
                  font-weight: 700;
                  line-height: 42px;
                }
                h6 {
                  color: $neutral80;
                  text-align: center;
                  font-family: 'Poppins-Regular', sans-serif;
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 24px;
                }
                ul {
                    margin-top: 5px;
                    margin-bottom: 15px;
                    li {
                        color : #DC3545;
                        font-weight: bold;
                    }
                }
                .modal-title {
                    position: absolute;
                    top: 16px;
                    right: 16px;
                    z-index: 1;
                    button.close {
                        padding: 0;
                        margin: 0;
                        background: transparent;
                        border: none;
                        opacity: 1;
                        cursor: pointer;
                        line-height: 1;
                        span {
                            font-size: 28px;
                            color: $neutralBlack;
                        }
                    }
                    button.close:hover span {
                        color: #333;
                    }
                }
                .main-content {
                    min-height: 350px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    h3 {
                        font-size: 20px;
                        line-height: 23px;
                        @include alternative-bold;
                    }
                    p {
                        font-size: 18px;
                        line-height: 26px;
                        @include alternative-regular;
                        margin-bottom: 19px;
                    }
                    .content-inner {
                        text-align: center;
                        width: 100%;
                    }
                    .text-content {
                        padding: 48px 24px 48px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        text-align: center;
                        img {
                            margin-right: 30px;
                            width: 203px;
                        }
                        img.clock {
                            width: auto;
                            margin-right: 6px;
                            transform: scale(0.6);
                        }
                        span {
                            font-size: 14px;
                        }
                        @include media-breakpoint-down(sm) {
                            display: flex;
                            flex-direction: column;
                            text-align: center;
                            padding: 48px 16px;
                            img {
                                margin-right: 0;
                                margin-bottom: 18px;
                                width: 146px;
                            }
                        }
                    }
                    .button {
                         @include media-breakpoint-up(sm){
                             width:160px;
                        }
                    }
                }

                .btn-outlet-continuar {
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  gap: 8px;
                  padding: 12px 24px;
                  height: 48px;
                  border-radius: 100px;
                  font-family: 'Poppins-Medium', sans-serif;
                  font-size: 1rem;
                  font-weight: 500;
                  cursor: pointer;
                  transition: all 0.2s ease;
                  outline: none;
                  border: none;
                  background: #000;
                  color: #fff;
                }
                .btn-outlet-continuar:hover {
                  background: #333;
                }

                .message{
                  padding: 12px 16px;
                  border-radius: 8px;
                  border: 1px solid #F1C469;
                  background: #FFFAF0;

                  span{
                    color: #966A11;
                    font-family: 'Poppins-Regular', sans-serif;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 22px; 
                  }
                }

                .imagen-content{
                  padding-top: 70px;
                }

            }

        }
    }

</style>